import { useOutletContext } from "react-router-dom";
import addresses from "./contactOptions";
import locationIcon from "../../../images/icons/location.svg";
import YaMap from "./Map";

const Contacts = () => {
  const { handleModal } = useOutletContext();

  const openMapHandler = (coordinate) => {
    handleModal(true, <MapContent coordinate={coordinate} />);
  };

  const MapContent = ({ coordinate }) => (
    <div className="contacts-map-content">
      <YaMap coordinate={coordinate} />
    </div>
  );

  return (
    <div className="contacts page-width">
      <div className="addresses-container flex-column gap-grid w-100">
        {addresses.map((item) => (
          <div className="card flex-column gap-4x w-100 border-radius-base">
            <div className="head w-100">
              <h2>{item.city}</h2>
            </div>
            <div className="body w-100">
              <div className="info gap-5x w-100">
                {item.contact !== null && (
                  <div className="info-item flex-column column-start gap-4x">
                    <span className="text-xs title">Адрес</span>
                    <div className="flex-column column-start gap-3x">
                      <span className="text-m">{item.contact.address}</span>
                      <span className="text-m">{item.contact.phone}</span>
                      <span className="text-m">{item.contact.email}</span>
                    </div>
                  </div>
                )}
                {item.representative !== null && (
                  <div className="info-item flex-column column-start gap-4x">
                    <span className="text-xs title">Представитель</span>
                    <div className="flex-column column-start gap-3x">
                      <span className="text-m">{item.representative.name}</span>
                      <span className="text-m">
                        {item.representative.phone}
                      </span>
                      <span className="text-m">
                        {item.representative.email}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              {item.contact !== null && (
                <div className="button-container">
                  <button
                    type="button"
                    className="size-m border-radius-s text-m"
                    onClick={() => openMapHandler(item.contact.coords)}
                  >
                    Смотреть на карте <img src={locationIcon} alt="location" />
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Contacts;
